import { ITEM_KINDS, STATES } from '../../../constants';
import { selectors } from '../../../state';

let channelClientName = '';
const getTitle = () => `Access Your ${channelClientName} Portal`;

export function ResidentPortalConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_RESIDENT_PORTAL, {
    url: '/resident-portal',
    views: {
      '@': {
        template: '<upd-resident-portal></upd-resident-portal>',
      },
    },
    scrollTop: true,
    title: getTitle,
    titleBar: {
      title: getTitle,
      icon: 'lock',
    },
    analytics: {
      page: 'Resident Portal',
    },
    data: {
      moveItem: {
        type: ITEM_KINDS.RESIDENT_PORTAL,
        singleton: true,
      },
    },
    onEnter: updStore => {
      channelClientName = selectors.current
        .siteConfig()
        .channelClientName(updStore.getState());
    },
  });
}
